import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiClient from '../api/axios';

const DuplicateSongToast = ({ message, songId }) => (
    <div>
        {message} <Link to={`/songs/${songId}`} className="toast-link">Перейти к песне</Link>
    </div>
);

const UploadSongFileModal = ({ show, onClose, onUploadSuccess }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState('');

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const validExtensions = ['.chordpro', '.chopro', '.cho', '.onsong'];
            const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            
            if (validExtensions.includes(fileExtension)) {
                setSelectedFile(file);
                setError('');
            } else {
                setSelectedFile(null);
                setError('Неверный формат. Выберите файл .chordpro, .chopro, .cho или .onsong');
            }
        }
    };

    const handleClose = () => {
        setSelectedFile(null);
        setError('');
        setIsUploading(false);
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFile) {
            setError('Пожалуйста, выберите файл для загрузки.');
            return;
        }

        setIsUploading(true);
        setError('');

        const formData = new FormData();
        formData.append('file', selectedFile);

        try {
            const response = await apiClient.post('/songs/upload_from_file', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            const newSong = response.data;
            toast.success(`Песня "${newSong.title}" успешно создана!`);
            onUploadSuccess(newSong);
            handleClose();
        } catch (err) {
            if (err.response && err.response.status === 409 && err.response.data.detail.song_id) {
                const { message, song_id } = err.response.data.detail;
                toast.error(<DuplicateSongToast message={message} songId={song_id} />);
                setError('Песня с таким названием уже существует.'); // Also show form error
            } else {
                const errorMessage = err.response?.data?.detail || 'Произошла ошибка при загрузке файла.';
                toast.error(errorMessage);
                setError(errorMessage);
            }
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Создать песню из файла</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Выберите файл в формате ChordPro (.chordpro, .chopro, .cho) или OnSong (.onsong).
                    Название, тональность и другие метаданные будут автоматически извлечены из файла.
                </p>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label>Файл песни</Form.Label>
                        <Form.Control 
                            type="file" 
                            onChange={handleFileChange} 
                            accept=".chordpro,.chopro,.cho,.onsong"
                            isInvalid={!!error}
                        />
                        {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
                    </Form.Group>
                    
                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={handleClose} className="me-2" disabled={isUploading}>
                            Отмена
                        </Button>
                        <Button 
                            variant="primary" 
                            type="submit" 
                            disabled={!selectedFile || isUploading}
                        >
                            {isUploading ? 'Загрузка...' : 'Создать'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default UploadSongFileModal;
